import http from '../../utils/httpService';
import { SEND_DIPLOMA_ROUTE } from './constants';

/**
 *
 * @param form
 */
const sendDiploma = form => (
    http.request(SEND_DIPLOMA_ROUTE, 'POST', form ,true)
);

export { sendDiploma };